// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__2Vkqz","frame":"Dialog_frame__2uZLf","closeButton":"Dialog_closeButton__2xjey","okButton":"Dialog_okButton__3w7VT","body":"Dialog_body__3x95r"};